import { defineMessages } from 'react-intl';
import type { BvDocType, DvDocType } from '@foundershub/api-client';

export const bvDocumentTypeLabels = defineMessages<BvDocType>({
  BV_001: {
    defaultMessage: 'Formation documents, such as articles of incorporation, partnership deed',
    description: 'business verification appeal doc type',
  },
  BV_002: {
    defaultMessage: 'Franchise or agency appointment letters',
    description: 'business verification appeal doc type',
  },
  BV_003: {
    defaultMessage: 'Government issued letter, license, registration, or certificate',
    description: 'business verification appeal doc type',
  },
  BV_004: { defaultMessage: 'Lease or tenancy documents', description: 'business verification appeal doc type' },
  BV_005: {
    defaultMessage: 'Letter or statement from a financial institution or a utility company',
    description: 'business verification appeal doc type',
  },
  BV_006: {
    defaultMessage: 'Record on a Government registry website (site/link must be displayed)',
    description: 'business verification appeal doc type',
  },
  BV_007: {
    defaultMessage: 'Stock exchange filings or tax filing records',
    description: 'business verification appeal doc type',
  },
});

export const dvDocumentTypeLabels = defineMessages<DvDocType>({
  DV_001: {
    defaultMessage: 'Assignment letter from an authorized representative of the organization',
    description: 'domain verification appeal doc type',
  },
  DV_002: {
    defaultMessage: 'Domain ownership records, such as Whois',
    description: 'domain verification appeal doc type',
  },
  DV_003: {
    defaultMessage: 'Domain purchase invoices or registry confirmation records',
    description: 'domain verification appeal doc type',
  },
  DV_004: {
    defaultMessage: 'Website showing name, address, contact information, and domain of the organization',
    description: 'domain verification appeal doc type',
  },
});
